import { render, staticRenderFns } from "./AddJobMilkForm.vue?vue&type=template&id=288fb87a&"
import script from "./AddJobMilkForm.vue?vue&type=script&lang=ts&"
export * from "./AddJobMilkForm.vue?vue&type=script&lang=ts&"
import style0 from "./AddJobMilkForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports